export default "<div fxLayout=\"row\" fxLayoutAlign=\"center center\" fxFlexFill>\n  <h1>404 - PAGE NOT FOUND</h1>\n</div>\n";